export function transformPreferences(input: { [key: string]: any }, searchProfile?: number | string) {
  if (!input) {
    return null;
  }

  const transformedPreferences: { [key: string]: any } = {};

  for (const group in input) {
    if (input.hasOwnProperty(group)) {
      if (group === 'general' || group === searchProfile) {
        transformedPreferences[group] = Object.values(input[group]);
      }
    }
  }

  return transformedPreferences;
}
